export default __webpack_public_path__ + "static/media/BHS.795d6303.svg";